<template>
    <div>
        <v-card>
            <v-alert
                :value="true"
                type="info"
            >
                This log displays active sessions for this user including IP address, user agent, and last activity time. You can use this information to monitor for any suspicious activity on the account, and log out of all sessions using the "End All Sessions" button above.<br /><br />
                {{ app_name }} logs out automatically after 15 minutes of inactivity with a tab open, or after 30 minutes with no tabs open.
            </v-alert>
            <v-data-table
                :items="data"
                :headers="headers"
                :pagination.sync="pagination"
                :total-items="totalSessions"
                :rows-per-page-items="paginationStrings"
                :loading="loading"
                disable-initial-sort
            >
                <template slot="items" slot-scope="props">
                    <tr>
                        <td>
                            {{ props.item.ip }}
                        </td>
                        <td>
                            {{ props.item.user_agent }}
                        </td>
                        <td>
                            {{ convertToCalRef(props.item.last_activity) }}
                        </td>
                        <td>
                            <v-btn
                                v-if="props.item.session_key !== 'current'"
                                small
                                color="red"
                                dark
                                @click="endSession(props.item.session_key)"
                            >
                                End Session
                            </v-btn>
                            <div
                                v-else
                            >
                                Your Current Session
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import api from '@/api'
import pagination from '@/components/global/pagination'

export default {
    name: 'UserActivityLog',
    props: ['user'],
    mixins: [
        pagination
    ],
    data () {
        return {
            data: [],
            headers: [
                { text: 'IP Address', width: '15%', value: 'ip', sortable: false},
                { text: 'User Agent', width: '50%', value: 'user_agent', sortable: false},
                { text: 'Last Activity', value: 'last_activity', sortable: true},
                { text: 'Actions', sortable: false}
            ],
            pagination: {
                rowsPerPage: 25
            },
            loading: true,
            routing: false,
            paginationStrings: [
                25, 50
            ],
        }
    },
    computed: {
        totalSessions () {
            return this.pagination.totalItems
        }
    },
    methods: {
        fetch(){
            this.loading = true
            api.users.user.getSessions(this.user)
            .then((data) => {
                this.data = data
                this.loading = false
                this.componentCreated = true
            })
        },
        endSession(sessionKey){
            this.loading = true
            api.users.user.endSession(this.user, sessionKey)
            .then((data) => {
                this.data = data
                this.loading = false
                this.componentCreated = true
            })
        },
    }
}

</script>